// extracted by mini-css-extract-plugin
export default {"customField":"CustomExtendedDataField_customField__qwZyL","compactNumericField":"CustomExtendedDataField_compactNumericField__f5R3m"};